module.exports = __webpack_public_path__ + "static/media/43.a5cf6f34.jpg";